import { Link, useParams } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { Breadcrumb } from "ui";
import { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

const HashtagDetails = () => {
    const id = useParams().id;

    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        },
        {
            path: "/hashtags",
            text: "Hashtags"
        }
    ];
    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full h-full flex relative  overflow-auto">
                <div className="w-full flex flex-col px-10 py-2">
                    <div className="w-full text-center">
                        <div className="flex justify-between items-center w-full text-center">
                            <Link to="/hashtags">
                                <ArrowBackIosNewRoundedIcon
                                    fontSize="small"
                                    className="dark:text-white"
                                />
                            </Link>
                            <Breadcrumb
                                breadcrumb={breadcrumb}
                                currentPath="Details"
                            />
                        </div>
                        <h1 className="font-medium text-lg dark:text-white py-8">
                            #name1
                        </h1>
                    </div>
                    <div className="w-full flex justify-center items-center gap-5">
                        <Link
                            className="bg-momeento-50 text-white text-center rounded-full w-fit px-3 py-1"
                            style={{ width: "150px" }}
                            to={`/hashtags/view/${id}`}
                        >
                            Details
                        </Link>
                        <Link
                            className="bg-momeento-50 text-white text-center rounded-full w-fit px-3 py-1"
                            style={{ width: "150px" }}
                            to={`/hashtags/view/${id}/posts`}
                        >
                            Posts/Incidents
                        </Link>
                    </div>

                    <div className="w-full items-center flex flex-col gap-10 px-10 py-5">
                        <Outlet />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HashtagDetails;
